// extracted by mini-css-extract-plugin
export default {"image":"_X-z","loaded":"aY-z"};